import classNames from 'classnames'
import css from '../AuthorProfile.styles.scss'

const Certifications = ({ author }) => {
  if (author.credentials && author.credentials.length > 0) {
    return (
      <div id="credentials" className={classNames(css.authorProfileSection)}>
        <h2>Certifications</h2>
        <ul>
          {author.credentials.map((credential, i) => (
            <li key={i}>
              <strong>{credential.issuingOrganization}</strong> -{' '}
              {credential.name}
            </li>
          ))}
        </ul>
      </div>
    )
  } else {
    return null
  }
}

export default Certifications
